import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import GlobalComponents from "./Plugin/GlobalComponent";
import { createPinia } from "pinia";
import piniaPersistedstate from "pinia-plugin-persistedstate";
import "remixicon/fonts/remixicon.css";
import "vue3-toastify/dist/index.css";





const pinia = createPinia();
pinia.use(piniaPersistedstate);

createApp(App)
.use(router)
.use(GlobalComponents)
.use(pinia)
.mount('#app')
